export default {
  path: '/admin',
  children: [
    {
      path: 'logs', 
      name: 'AdminLogs',
      component: () => import('../views/admin/logManagement.vue'),
      meta: { 
        requiresAuth: true, 
        requiresAdmin: true,
        title: '로그 관리'
      }
    },
    {
      path: 'users', 
      name: 'AdminUsers',
      component: () => import('../views/admin/userManagement.vue'),
      meta: { 
        requiresAuth: true, 
        requiresAdmin: true,
        title: '사용자 관리'
      }
    }
  ]
};
